import { useAuth } from './use-auth';
import { Roles } from '@/lib/types';

export default function useIsViewer() {
  const auth = useAuth();
  return auth.role && auth.role?.id === Roles.WorkspaceViewer;
}
